import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login';
import Home from './views/Home';
import store from '@/store/store';
import Community from './views/Community.vue';
import CommunityMembers from './views/CommunityMembers.vue';
import CommunityTickets from './views/CommunityTickets.vue';
import Cards from './views/CommunityCards.vue';
import Profile from '@/views/Profile';
import CommunityPolls from '@/views/CommunityPolls';
import CommunityEvents from '@/views/CommunityEvents';
import CommunityPosts from '@/views/CommunityPosts';
import CommunityFinances from '@/views/CommunityFinances';
import CommunityFinancesHome from '@/views/CommunityFinancesHome';
import CommunityFinancesMember from '@/views/CommunityFinancesMember';
import CommunityTransactions from '@/views/CommunityTransactions';
import CommunityInvoices from '@/views/CommunityInvoices';
import CommunityExpenses from '@/views/CommunityExpenses';

import Tickets from './views/AllTickets.vue';
import Reminders from './views/AllReminders.vue';
import Polls from './views/AllPolls.vue';
import Inbox from './views/Inbox.vue';
import Dashboard from './views/Dashboard.vue';
import PostDetails from './views/PostDetails';
import Events from './views/AllEvents.vue';
import Treasury from './views/Treasury.vue';
import Notifications from './views/Notifications';
import NotFound from './views/NotFound';
import Ticket from '@/components/common/Ticket.vue';
import Poll from '@/components/post/Poll.vue';
import Event from '@/components/post/Event.vue';
import Post from '@/components/post/Post.vue';
import NewCommunity from '@/views/NewCommunity.vue';
import CommunitySearch from '@/views/CommunitySearch.vue';
import CommunityDocuments from '@/views/CommunityDocuments.vue';
import AllContractors from '@/views/AllContractors.vue';
import UserManagement from '@/views/UserManagement.vue';
import ContractorDetails from '@/views/ContractorDetails.vue';
import ProjectDetails from '@/views/ProjectDetails.vue';
import PropertyDetails from '@/views/PropertyDetails.vue';
import CommunityInfrastructure from '@/views/CommunityInfrastructure.vue';
import CommunityInfrastructureDetails from '@/views/CommunityInfrastructureDetails.vue';
import CommunityReminderDetails from '@/views/CommunityReminderDetails.vue';
import CommunityReminders from '@/views/CommunityReminders.vue';
import ManagerDetails from '@/views/ManagerDetails.vue';
import Projects from '@/views/Projects.vue';

import axios from '@/axios/axios.js';

// const Home = () => import('./views/Home');

Vue.use(Router);

const router = new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'communitySearch',
      component: CommunitySearch
    },
    {
      path: '/new-community',
      name: 'newCommunity',
      component: NewCommunity
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter(to, from, next) {
        store.commit('unsetUser');
        delete axios.defaults.headers.common['Authorization'];
        localStorage.removeItem('k-d');
        localStorage.removeItem('k-t');
        localStorage.removeItem('k-active-community');
        localStorage.removeItem('k-ti-m');
        localStorage.removeItem('k-po-m');
        localStorage.removeItem('k-p-m');
        localStorage.removeItem('k-e-m');
        localStorage.removeItem('k-po-m');
        localStorage.removeItem('k-active-c-id');
        localStorage.removeItem('k-com');
        localStorage.removeItem('k-last-active');
        store.commit('clearRefreshInterval');
        next('login');
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'home',
      component: Dashboard
    },
    {
      path: '/community/:id',
      component: Community,
      children: [
        {
          path: '',
          name: 'community',
          component: CommunityMembers
        },
        {
          path: 'polls',
          name: 'communityPolls',
          component: CommunityPolls
        },
        {
          path: 'tickets',
          name: 'communityTickets',
          component: CommunityTickets
        },
        {
          path: 'members',
          name: 'communityMembers',
          component: CommunityMembers
        },
        {
          path: 'property/:propertyId',
          name: 'propertyDetails',
          component: PropertyDetails
        },
        {
          path: 'events',
          name: 'communityEvents',
          component: CommunityEvents
        },
        {
          path: 'posts',
          name: 'communityPosts',
          component: CommunityPosts
        },
        {
          path: 'documents',
          name: 'communityDocuments',
          component: CommunityDocuments
        },
        {
          path: 'finances',
          component: CommunityFinances,
          children: [
            {
              path: '',
              name: 'communityFinancesHome',
              component: CommunityFinancesHome
            },
            {
              path: 'member/:memberId',
              name: 'communityFinancesMember',
              component: CommunityFinancesMember
            }
          ]
        },
        {
          path: 'transactions',
          name: 'communityTransactions',
          component: CommunityTransactions
        },
        {
          path: 'invoices',
          name: 'communityInvoices',
          component: CommunityInvoices
        },
        {
          path: 'expenses',
          name: 'communityExpenses',
          component: CommunityExpenses
        },
        {
          path: 'infrastructure',
          name: 'communityInfrastructure',
          component: CommunityInfrastructure
        },
        {
          path: 'infrastructure/:infrastructureId',
          name: 'communityInfrastructureDetails',
          component: CommunityInfrastructureDetails
        },
        {
          path: 'reminders',
          name: 'communityReminders',
          component: CommunityReminders
        },
        {
          path: 'reminders/:reminderId',
          name: 'communityReminderDetails',
          component: CommunityReminderDetails
        }
      ]
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: Tickets
    },
    {
      path: '/reminders',
      name: 'reminders',
      component: Reminders
    },
    {
      path: '/events',
      name: 'events',
      component: Events
    },
    {
      path: '/treasury',
      name: 'treasury',
      component: Treasury
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications
    },
    {
      path: '/details',
      name: 'postDetails',
      component: PostDetails,
      children: [
        {
          path: '/ticket/:ticketId',
          name: 'ticketDetails',
          component: Ticket
        },
        {
          path: '/poll/:pollId',
          name: 'pollDetails',
          component: Poll
        },
        {
          path: '/event/:eventId',
          name: 'eventDetails',
          component: Event
        },
        {
          path: '/post/:postId',
          name: 'communityPostDetails',
          component: Post
        }
      ]
    },
    {
      path: '/polls',
      name: 'polls',
      component: Polls
    },
    {
      path: '/inbox',
      name: 'inbox',
      component: Inbox
    },
    {
      path: '/contractors',
      name: 'contractors',
      component: AllContractors
    },
    {
      path: '/contractor/:contractorId',
      name: 'contractorDetails',
      component: ContractorDetails
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/projects/:projectId',
      name: 'projectDetails',
      component: ProjectDetails
    },
    {
      path: '/user-management',
      name: 'userManagement',
      component: UserManagement
    },
    {
      path: '/user/:userId',
      name: 'managerDetails',
      component: ManagerDetails
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (from.name != 'community' && to.name == 'community') {
    // replace route param with new active community id
    let newCommunityId = to.params.id;
    switch (from.name) {
      case 'communityPolls':
        store.commit('setActiveCommunity', newCommunityId);
        next('/community/' + newCommunityId + '/polls');
        break;
      case 'communityTickets':
        next('/community/' + newCommunityId + '/tickets');
        break;
      case 'communityMembers':
        next('/community/' + newCommunityId + '/members');
        break;
      case 'communityEvents':
        next('/community/' + newCommunityId + '/events');
        break;
      case 'communityFinancesHome':
        next('/community/' + newCommunityId + '/finances');
        break;
      case 'communityPosts':
        next('/community/' + newCommunityId + '/posts');
        break;
      case 'communityDocuments':
        next('/community/' + newCommunityId + '/documents');
        break;
      case 'communityInfrastructure':
        next('/community/' + newCommunityId + '/infrastructure');
        break;
      case 'communityReminders':
        next('/community/' + newCommunityId + '/reminders');
        break;
    }
  }
  if (!store.getters['getUser']) {
    if (localStorage.getItem('k-t')) {
      let token = localStorage.getItem('k-t');
      let data = JSON.parse(localStorage.getItem('k-d'));
      const activeCommunityId = localStorage.getItem('k-active-c-id');
      const ticketBasicInfo = JSON.parse(localStorage.getItem('k-ti-m'));
      const pollBasicInfo = JSON.parse(localStorage.getItem('k-p-m'));
      const eventBasicInfo = JSON.parse(localStorage.getItem('k-e-m'));
      const postBasicInfo = JSON.parse(localStorage.getItem('k-po-m'));
      const company = JSON.parse(localStorage.getItem('k-com'));
      const lastActiveCommunites = JSON.parse(
        localStorage.getItem('k-last-active')
      );
      axios.defaults.headers.common['Auth'] = token;
      store.commit('setUser', {
        username: data.full_name,
        email: data.email,
        id: data.id,
        phone: data.phone,
        profile_pic_URL: data.profile_pic_URL,
        roles: data.roles
      });
      store.commit('setCommunities', data.communities);
      store.commit('setActiveCommunity', activeCommunityId);
      store.commit('setLastActiveCommunities', lastActiveCommunites);
      store.commit('ticket/setBasicInfo', ticketBasicInfo);
      store.commit('poll/setBasicPollInfo', pollBasicInfo);
      store.dispatch('event/setBasicInfo', eventBasicInfo);
      store.commit('event/setEventDetails', eventBasicInfo);
      store.commit('post/setBasicPostInfo', postBasicInfo);
      store.commit('setCompany', company);
    }
  }

  // login guard
  if (to.name !== 'login' && store.getters.getUser == null) {
    next('/login');
  } else {
    next();
  }
  /*
   * setting active community if user navigate through
   * url manipulation*/
  if (
    to.name !== 'login' &&
    from.params.id &&
    to.params.id &&
    from.params.id !== to.params.id
  ) {
    store.commit('setActiveCommunity', to.params.id);
  }
});

export default router;
